<template>
    <div class=" margin-top-20">
        <div class="product-param-father">
            <div class="index-div-content  product-info-div-no-padding  background-white   ">

                <h3 class="margin-bottom-20 center color-1B1B1B font-28 ">
                    <img src="../../assets/img/1.png" width="31" alt="">
                    <span style="margin:0 20px">产品参数</span>
                    <img src="../../assets/img/2.png" width="31" alt="">
                </h3>
                <div class="center">
                </div>
                <div class="product-param-table" >
                    <table class="table" >
                        <thead>
                        <tr><th class="th" colspan="2">产品参数</th></tr>
                        </thead>
                        <tbody>

                        <tr class="tbody-tr" v-for="item in productJson[productInfo]">
                            <td class="name">{{item.name}}</td>
                            <td class="value">{{item.value}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table no-top-border" >
                        <thead>
                        <tr><th class="th" colspan="2">环境参数</th></tr>
                        </thead>
                        <tbody>

                        <tr class="tbody-tr" v-for="item in productJson[productProvince]">
                            <td class="name">{{item.name}}</td>
                            <td class="value">{{item.value}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import ProductJson from "../../json/ProductJson";
    export default {
        name: "ProductInfo",
        props:["productInfo","productProvince"],
        data(){
            return{
                productJson:ProductJson
            }

        }
    }
</script>

<style scoped lang="scss">
.table{
    margin:  0 auto ;
    width: 98%;
    border: 1px solid #CCCCCC;
    border-collapse:collapse;
    .name{
        width: 30%;
        border: 1px solid #CCCCCC;
        border-bottom: none;
    }
    .value{
        width: 70%;
        border: 1px solid #CCCCCC;
        border-left: none;
        border-bottom: none;
    }
    .th{
        background: #EFEFEF;
        border: 1px solid #CCCCCC;
        color: #1B1B1B;
        font-weight: bolder;
        font-size: 18px;
        line-height: 40px;


    }
    td{
        line-height: 29px;
        padding-left: 20px;
    }


}
.table.no-top-border{
    border: none;
    border-bottom:1px solid #CCCCCC ;
    .th{
        border-top: none;
    }
}
</style>